import { render, staticRenderFns } from "./PlayersContainer.vue?vue&type=template&id=a6d676a6"
import script from "./PlayersContainer.vue?vue&type=script&lang=js"
export * from "./PlayersContainer.vue?vue&type=script&lang=js"
import style0 from "./PlayersContainer.vue?vue&type=style&index=0&id=a6d676a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports